/**
 * Discovers `*-active.svg` files under assets/sidebar-icons so SidebarIcon can
 * crossfade idle + active without maintaining a manual name list.
 *
 * **Contract:** every `foo.svg` in that folder must have `foo-active.svg` (and
 * vice versa). Enforced by `sidebar-icon-active-variant-names.spec.ts`.
 *
 * Lazy glob: we only need path keys to derive base names — do not eager-load
 * every `*-active.svg` module into this chunk.
 */
const activeSidebarIconGlob = import.meta.glob('../assets/sidebar-icons/*-active.svg')

const activeFileSuffixRe = /([^/]+)-active\.svg$/

const baseNamesFromActivePaths = Object.keys(activeSidebarIconGlob)
  .map(key => {
    const match = activeFileSuffixRe.exec(key)
    return match?.[1] ?? ''
  })
  .filter(Boolean)

export const SIDEBAR_ICON_NAMES_WITH_ACTIVE_VARIANT = new Set(baseNamesFromActivePaths)

export function sidebarIconHasActiveVariant(iconName: string): boolean {
  return SIDEBAR_ICON_NAMES_WITH_ACTIVE_VARIANT.has(iconName)
}
